import request from '@/router/axios';

export const listByWeek = (data) => {
  return request({
    url: '/api/produce/transport-plan-schedule/listByWeek',
    method: 'post',
    data
  });
};

export const saveWeek = (data) => {
  return request({
    url: '/api/produce/transport-plan-schedule/saveWeek',
    method: 'post',
    data
  });
};

export const bladeDeptDistinct = (params) => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  });
};
